import React from "react";
import { MenuItem, Box, Typography } from "@mui/material";
import { JOURNAL_TYPES } from "./journalEntryConstants";

/**
 * Creates memoized journal type menu items for performance
 */
export const createJournalTypeMenuItems = () => {
  return JOURNAL_TYPES.flatMap((group) => [
    <MenuItem
      key={`group-${group.group}`}
      disabled
      sx={{
        fontWeight: 700,
        color: "text.primary",
        bgcolor: "rgba(0, 0, 0, 0.04)",
        fontSize: "0.8rem",
        py: 1.5,
        px: 2,
        letterSpacing: "0.5px",
        textTransform: "uppercase",
        borderBottom: "1px solid rgba(0, 0, 0, 0.08)",
        "&:hover": {
          bgcolor: "rgba(0, 0, 0, 0.04)",
        },
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Box
          sx={{
            width: 3,
            height: 16,
            bgcolor: "primary.main",
            borderRadius: 0.5,
          }}
        />
        {group.group}
      </Box>
    </MenuItem>,
    ...group.types.map((type, index) => (
      <MenuItem
        key={type.value}
        value={type.value}
        sx={{
          pl: 4,
          py: 1.5,
          borderBottom:
            index === group.types.length - 1
              ? "1px solid rgba(0, 0, 0, 0.05)"
              : "none",
          "&:hover": {
            bgcolor: "rgba(25, 118, 210, 0.04)",
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 2,
            width: "100%",
          }}
        >
          <Box
            sx={{
              width: 6,
              height: 6,
              borderRadius: "50%",
              bgcolor: `${type.color}.main`,
              flexShrink: 0,
            }}
          />
          <Box sx={{ flex: 1 }}>
            <Typography
              variant="body2"
              sx={{
                fontWeight: 500,
                color: "text.primary",
                lineHeight: 1.2,
              }}
              title={type.description}
            >
              {type.label}
            </Typography>
          </Box>
        </Box>
      </MenuItem>
    )),
  ]);
};
